import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { CertificatePage } from './pages/CertificatePage';
import { MyLandsPage } from './pages/MyLandsPage';
import { LandDetailsPage } from './pages/LandDetailsPage';
import { ServicesPage } from './pages/ServicesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { ProfilePage } from './pages/ProfilePage';
import { ReportsPage } from './pages/ReportsPage';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { BottomNav } from './components/BottomNav';
import { notificationsData, landsData as initialLandsData } from './data/sampleData';
import { translations } from './data/translations';
type Page = 'landing' | 'login' | 'dashboard' | 'certificate' | 'mylands' | 'landdetails' | 'services' | 'notifications' | 'profile' | 'reports';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('landing');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [selectedLandId, setSelectedLandId] = useState<string | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [language, setLanguage] = useState<'bn' | 'en'>('bn');
  const [lands, setLands] = useState(initialLandsData);
  const t = (key: string) => translations[language][key] || key;
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  const navigate = (page: string, landId?: string) => {
    if (page === 'landing') {
      setIsAuthenticated(false);
    }
    setCurrentPage(page as Page);
    if (landId) {
      setSelectedLandId(landId);
    }
    setIsSidebarOpen(false);
  };
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    navigate('dashboard');
  };
  const addLand = (newLand: any) => {
    setLands([...lands, newLand]);
  };
  const getPageTitle = () => {
    switch (currentPage) {
      case 'dashboard':
        return t('nav.dashboard');
      case 'certificate':
        return t('nav.certificate');
      case 'mylands':
        return t('nav.mylands');
      case 'landdetails':
        return t('details.title');
      case 'services':
        return t('nav.services');
      case 'notifications':
        return t('nav.notifications');
      case 'profile':
        return t('nav.profile');
      case 'reports':
        return t('nav.reports');
      default:
        return '';
    }
  };
  const unreadCount = notificationsData.filter(n => !n.read).length;
  // Unauthenticated routes
  if (currentPage === 'landing') {
    return <LandingPage navigate={navigate} t={t} data-id="element-0" />;
  }
  if (currentPage === 'login') {
    return <LoginPage onLoginSuccess={handleLoginSuccess} navigate={navigate} t={t} data-id="element-1" />;
  }
  // Authenticated Layout
  if (!isAuthenticated) {
    return <LandingPage navigate={navigate} t={t} data-id="element-2" />;
  }
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-3">
      <Sidebar currentPage={currentPage} navigate={navigate} notificationCount={unreadCount} isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} t={t} data-id="element-4" />

      <div className="flex-1 flex flex-col min-w-0 lg:ml-64 transition-all duration-300" data-id="element-5">
        <Header title={getPageTitle()} onMenuClick={() => setIsSidebarOpen(true)} notificationCount={unreadCount} navigate={navigate} language={language} setLanguage={setLanguage} data-id="element-6" />

        <main className="flex-1 p-4 md:p-6 lg:p-8 overflow-x-hidden" data-id="element-7">
          <div className="max-w-7xl mx-auto" data-id="element-8">
            {currentPage === 'dashboard' && <DashboardPage navigate={navigate} t={t} lands={lands} data-id="element-9" />}
            {currentPage === 'certificate' && <CertificatePage navigate={navigate} t={t} lands={lands} data-id="element-10" />}
            {currentPage === 'mylands' && <MyLandsPage navigate={navigate} t={t} lands={lands} addLand={addLand} data-id="element-11" />}
            {currentPage === 'landdetails' && <LandDetailsPage landId={selectedLandId} navigate={navigate} t={t} lands={lands} data-id="element-12" />}
            {currentPage === 'services' && <ServicesPage navigate={navigate} t={t} lands={lands} data-id="element-13" />}
            {currentPage === 'notifications' && <NotificationsPage navigate={navigate} t={t} data-id="element-14" />}
            {currentPage === 'profile' && <ProfilePage t={t} data-id="element-15" />}
            {currentPage === 'reports' && <ReportsPage t={t} lands={lands} data-id="element-16" />}
          </div>
        </main>
      </div>

      <BottomNav currentPage={currentPage} navigate={navigate} notificationCount={unreadCount} t={t} data-id="element-17" />
    </div>;
}